// extracted by mini-css-extract-plugin
module.exports = {"button":"_3kQ-Jx","whiteColor":"_37J_Rq","icon":"beIgHA","brandColor":"_22fYzc"};